import React from 'react';
import styles from './RoundedSpinner.css';

function RoundedSpinner() {
  return (
    <div className={styles.RoundedSpinner}>
      <div className={styles.RoundedSpinner__circle} />
    </div>
  );
}

export default RoundedSpinner;
